<template>
  <div class="body">
    <div class="member">
      <!-- 规则 -->
      <!-- <div class="rule" @click="showRules"></div> -->
      <!-- 输入手机号码-->
      <div>
        <div class="input1" v-if="isShowMobileInput">
          <input
            type="tel"
            v-model="mobile"
            maxlength="11"
            placeholder="请输入您的手机号码"
          />
          <img
            src="https://mydcdn.boshgame.com/resource/img20230208/tel.png"
            style="position: absolute;left: 4.7%;  top: 25%;width: 28px;  height: 34px;"
          />
        </div>
        <div class="input2" v-if="isShowCodeInput">
          <input
            type="number"
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
          />
          <img
            src="https://mydcdn.boshgame.com/resource/img20230208/code.png"
            style="position: absolute;left: 4.7%;  top: 25%;width: 28px;  height: 34px;"
          />
          <button
            class="button2"
            name="button"
            @click="okPrizeMobileBtn()"
            v-show="codeShow"
          >
            获取验证码
          </button>
          <button class="button2" name="button2" v-show="!codeShow">
            {{ count }}秒后重试
          </button>
        </div>

        <div
          class="showPrizeBtn"
          @click="handleComfirm"
          v-if="isShowMobileInput"
        ></div>
        <!-- 按钮1 -->
        <!-- <div
          class="showPrizeCodeBtn"
          @click="okPrizeBtn"
          v-if="isShowCodeInput"
        ></div> -->

        <div class="showPrivacyPolicy">
          <input
            type="checkbox"
            id="agreementRadio"
            style="width: 12px;height: 12px; display: inline-block; vertical-align: middle; background-color: white;"
            :checked="checked"
          />
          <!--  checked="true" -->
          <span
            style="color: rgb(254, 197, 172); font-size: 10px; display: inline-block; vertical-align: middle;white-space:nowrap;letter-spacing: 2px;"
            >我已详细阅读并同意<span
              ><a
                href="https://wx.10086.cn/website/serviceAgreement.html"
                style="color: rgb(254, 197, 172); text-decoration: underline;"
                >《用户服务协议》</a
              ></span
            >及<span
              style="color: rgb(254, 197, 172); text-decoration: underline;"
              @click="showRules"
              >《解约条款》</span
            >
          </span>

          <div
            style="width: 100%; margin: 0px auto; text-align: center; font-size: 9px; color: rgb(254, 197, 172);"
          >
            <div
              style="margin: 0px 0px 0px; word-wrap:break-word;word-break: break-all;vertical-align: middle;white-space:nowrap;letter-spacing: 2px;"
            >
              资费:20元/月&nbsp;&nbsp;客服电话:13410338521
            </div>
          </div>
        </div>
      </div>

      <div class="quanyi1" @click="quanyi"></div>
    </div>

    <!-- 结果弹出框 -->
    <div
      v-if="isSHowResultDialog"
      id="orderResultSucDialog"
      class="dialog-scale-big"
      style="width: 100%; height: 100vh;z-index: 1002; position: absolute; align-items: center; justify-content: center; background-image: linear-gradient(rgba(0, 0, 0, 0.69) 0px, rgba(0, 0, 0, 0.69) 0px); top: 0px;"
    >
      <div class="result-center__d">
        <p class="result-center__title">订单已提交</p>
        <p class="result-center__sub-title">
          （成功开通后可获得权益奖励，开通结果以短信为准）
        </p>
        <div>
          <img
            src="../../static/img/mem/quanyi.png"
            style="width: 80%;  text-align: center;  margin: 0.8rem 0 0 0;"
            @click="quanyi"
          />
        </div>
        <!-- 扫描二维码 src="http://mydcdn.boshgame.com/resource/myd-qrcode.png"  class="result-center__qrCode"-->
        <!-- <p class="result-center__qrText">
          打开“微信”搜索“蚂蚁换”关注公众号领取权益
        </p> -->
        <div class="result-center__link">
          <a href="" style="text-decoration: underline;"></a>
        </div>
        <div class="result-center__btn-d" @click="isSHowResultDialog = false">
          我知道啦
        </div>
      </div>
    </div>

    <div class="Dialog-wrap" v-if="isSHowComfirmDialog" @click.stop="1">
      <div class="ComfirmDialog" @click.stop="1">
        <!-- <div class="input2">
          <input
            type="number"
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
          />
          <button
            class="button2"
            name="button"
            @click="okPrizeMobileBtn()"
            v-show="codeShow"
          >
            获取验证码
          </button>
          <button class="button2" name="button2" v-show="!codeShow">
            {{ count }}秒后重试
          </button>
        </div> -->

        <button
          class="ExitButton"
          name="ExitButton"
          @click="isSHowComfirmDialog = false"
        ></button>
        <button
          class="ComfirmButton"
          name="ComfirmButton"
          @click="handleOrder"
        ></button>
      </div>
    </div>

    <!-- 规则提示框 -->
    <div class="Dialog-wrap" v-if="isSHowRuleDialog" @click.stop="1">
      <div class="RuleDialog" @click.stop="1">
        <div
          style="position: absolute;width:80%;height:85%;top:10%;left: 9%; overflow:auto;"
        >
          <span
            style="font-size: 13px;text-align: justify;text-justify: newspaper;display: inline-block; color: rgb(215, 97, 0);white-space: pre-wrap;word-wrap:break-word;word-break: break-all;"
            >{{ JYText }}</span
          >
        </div>
        <img
          class="closeBtn"
          src="https://mydcdn.boshgame.com/resource/img20220927/close.png"
          @click="isSHowRuleDialog = false"
        />
      </div>
    </div>
  </div>
</template>
<script src="https://mydcdn.boshgame.com/resource/jsV1.2/bosh-core-httpsV1.0.1.js"></script>
<!--<script src="https://assets.giocdn.com/sdk/webjs/cdp/gdp-full.js"></script> -->
<!--<script src="../js/gdp-full.js"></script>-->

<script>
import CryptoJS from "crypto-js";
import "../js/gdp-full.js";

(function(window, document, script, src, namespace) {
  window[namespace] =
    window[namespace] ||
    function() {
      (window[namespace].q = window[namespace].q || []).push(arguments);
    };
  script = document.createElement("script");
  let tag = document.getElementsByTagName("script")[0];
  script.async = true;
  script.src = src;
  tag.parentNode.insertBefore(script, tag);
})(window, document, "script", "JS 资源地址", "gdp");

gdp("init", "8d2279a5e2f18b7c", "9d59ac736f01c688", {
  host: "collect.gmcc.net",
  compress: true,
  debug: true,
  scheme: "https",
  hashtag: true
});

function getCurTime() {
  let nowDate = new Date();
  let date = {
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
    date: nowDate.getDate(),
    hours: nowDate.getHours(),
    minutes: nowDate.getMinutes(),
    seconds: nowDate.getSeconds()
  };
  let newmonth = date.month > 10 ? date.month : "0" + date.month;
  let newday = date.date > 10 ? date.date : "0" + date.date;
  let newminutes = date.minutes < 10 ? "0" + date.minutes : date.minutes;
  let newseconds = date.seconds < 10 ? "0" + date.seconds : date.seconds;

  let newTime =
    date.year + newmonth + newday + date.hours + newminutes + newseconds;
  return newTime;
}

export default {
  inject: ["reload"],

  data() {
    return {
      codeTimer: null,
      isSHowResultDialog: false,
      mobile: "",
      code: "",
      count: 120,
      isShowMobileInput: true,
      isShowCodeInput: true,
      isSHowRuleDialog: false,
      isSHowComfirmDialog: false,
      codeShow: true,
      encryptedMessage: "",
      checked: false,
      orderId: "",
      orderNumber_var: "",
      ruleText:
        "1、活动时间:方案办理有效期至2025年12月31日。" +
        "\n2、活动对象:广东移动全品牌客户。其中2G/3G不限量套餐、4G随心王套餐、万花筒套餐、所有副号和虚拟号码(含多号通、一卡双号、家庭服务计划、万能副卡业务等)，或已办其他权益产品的客户无法办理，如需办理需先主动取消上述业务。如原已办业务属于不再发展的旧业务，取消业务后无法重办。网龄30天以内、号码状态异常、携号转网等客户不能办理。具体以办理结果为准。" +
        "\n3、【业务说明】本方案限办1次，合约期12个月，客户需每月正正常使用20元移动小福券(蜻蜓FM会员月卡，12个月版)至合约期满(合约生效后不得取消、不得办理其他权益产品)。合约期内，客户如办理过户、停机、销户、离网、营销活动中断等业务，视为违约。如客户违约，合约期内尚未享受的优惠将不再享受，退订和解约条款参照中国移动通信客户业务解约条款 http://dx.10086.cn/3dHGAQ。合约到期前有短信提醒合约期满后续订20元移动小福券，如客户不再使用业务，需主动取消。方案办理后立即生效，本产品费用不可使用赠送话费余额抵扣。" +
        "\n4、【业务详情】合约生效期间每月下发蜻蜓FM会员月卡、3GB国内通用流量(不含港澳台地区)、咪咕视频钻石会员以及移动云盘400GB融合网盘空间(200GB个人云空间+200GB家庭云空间)。另可领取蜓宝宝会员月卡并享有黄金会员身份(可参与大牌权益免费领、特惠购以及优惠福利抢购等活动)。领取权益请点击进入广东移动小程序 https://dx.10086.cn/z UHBQ，或进入“中国移动”APP-首页-小福券。" +
        "\n5、【补充说明】" +
        "\n   (1)合约期内权益由合作伙伴提供，如合作伙伴无法提供，为保障客户的合法权益，我司将通过公告的形式提前告知客户合作产品结束，并为客户切换成通用型权益月包或为客户取消合作产品。" +
        "\n   (2)合约到期后续订的通用型权益月包，具体可兑换的权益以当期页面上架权益为准，权益兑换价格以当期页面显示为准，具体权益的价格会因当期第三方合作情况动态调整，期间产生的兑换差额不做补退。" +
        "\n6、业务退订:用户拨打10086客服电话退订,或发送短信0000至10086进行退订;退订当月仍需收取产品功能费,退订次月生效。" +
        "\n7、客服服务:如有任何疑问及相关投诉建议,请拨打客服电话4006960698进行咨询、处理。",
      JYText:
        "解约条款" +
        "\n甲方：中国移动通信客户" +
        "\n乙方：中国移动通信集团广东有限公司" +
        "\n甲方业务协议解约按类型分为“直接解约”和“有条件解约”两大场景。" +
        "\n一、直接解约" +
        "\n主要是涉及甲方直接订购的业务，乙方未进行任何优惠或补贴，甲方也未得从乙方得到实物或权益等相关的业务，采用无条件直接解约。" +
        "\n二、有条件解约" +
        "\n1.合约业务" +
        "\n如涉及赠送终端、话费存送、设备租赁或承诺在网或承诺消费获得相应优惠等业务，一般不能直接解约，甲方在“完成优惠赔付、不影响二次销售的退货”等情况下，有条件解约，按解约标准和流程操作（如有事先签订赔付标准，按约定的赔付标准执行）。具体如下：" +
        "\n（1）资金优惠：如话费存送、套餐折扣等。解约条件：根据优惠、减免情况支付违约金。赔付标准：甲方如提前终止协议，则甲方需将已履行月份获赠金额或优惠减免金额总额、以及未履行月份所有低消或套餐金额总额的一定比例（法律规定范围内）进行赔付。" +
        "\n（2）业务赠送：如承诺消费送流量包、语音包、短信包等。解约条件：根据已赠送业务价值，支付合理的违约金。赔付标准：甲方如要求提前终止协议，则甲方需将已获赠业务进行价值折算进行赔付。非流量类（语音、短信等）按单价标准资费折算，流量类按实际单价优惠资费折算。" +
        "\n（3）宽带业务：如网龄送宽带，承诺低消送宽带。解约条件：提前终止宽带业务需对初装费或拆机费进行赔付。赔付标准：甲方如要求提前终止协议，需根据前期活动约定的初装费用或拆机费用进行赔付。" +
        "\n（4）实物赠送：如承诺消费送终端、充值卡等。解约条件：在不影响二次销售的前提下，退还赠送的实物；在无法退还实物的情况下，通过对实物进行折现，支付违约金。赔付标准：根据退货要求且不影响二次销售的前提下，可在完成赠送实物退货后解约；如赠送实物已不满足退货条件，则甲方需根据实物赠送价值及未履行承诺期限进行补偿。" +
        "\n（5）权益赠送：如咪咕视频、爱奇艺、优酷会员权益等。解约条件：需根据活动约定退回方可解约，不能退回需按价值折算进行补偿（权益赠送协议签订中应明确约定赠送权益的价值或折算方法）。赔付标准：权益未使用可在完成赠送权益回退后解约；权益已领取、使用，则甲方需将已使用权益进行价值折算，赔偿后解约。" +
        "\n（6）实物租赁：如家庭宽带机顶盒、光猫等。解约条件：确保设备完好的情况下，返还租赁物；如无法归还或涉及其他利益损失的，可通过折现，支付合理违约金。赔付标准：甲方如要求提前终止协议，需根据活动约定条件退回或赔偿租赁物，根据退货约定且不影响二次销售的前提下，可在完成租赁实物退回后解约（注，如租赁物非新：在确保设备完好的情况下，可在完成租赁物退货后解约）；如租赁物已不满足再次租赁条件（设备已无法正常使用），则甲方需根据租赁设备价值进行等价偿还。" +
        "\n2.融合业务" +
        "\n融合套餐、主副卡、统付、共享、家庭网、集团网、惠农网、双向亲情互打等业务，需在不影响其他甲方业务使用的情况下，根据具体情况进行退订或解除。" +
        "\n类别	场景	解约条件	举例" +
        "\n融合业务	统付业务、主副卡等	取消统付关系、解除相关成员	家庭统付、家庭网、集团网等" +
        "\n共享业务	解除共享关系	流量、语音共享等" +
        "\nV网	解除V网成员关联关系	家庭网、集团网、惠农网、双向亲情互打等" +
        "\n注：①主卡、共享者解除，应对其他成员尽到通知义务。" +
        "\n②副卡、被共享者解除，不应对其他成员权益造成损失。" +
        "\n3.吉祥号码业务" +
        "\n如四连号、三连号等吉祥号码。解约条件：按吉祥号码低消和未履行协议期进行赔付。赔付标准：如甲方要求提前终止协议，则甲方应当按照未履行月份所有低消或套餐金额总额向乙方支付损失赔偿金，如甲方有签约减免或降档低消金额特殊情况的，采用前述同样标准执行。（参考最新吉祥号码等级对应的低消或套餐标准）。" +
        "\n4.集团信息化业务" +
        "\n解约条件：根据乙方投入成本补贴和未履行时间等进行价值折算赔付（协议签订中应明确约定相关业务价值或折算方法）。" +
        "\n赔付标准：具体赔付标准按签订的协议条款折算。"
    };
  },
  //监听
  watch: {
    // mobile: function() {
    //   //手机号码校验
    //   const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    //   //alert(this.mobile + "-" + this.mobile.length);
    //   if (this.mobile.length >= 11 && reg.test(this.mobile)) {
    //     //勾选复选框
    //     //this.checked = true;
    //     $("[type='checkbox']").prop("checked", true);
    //     //提交手机号码
    //     let businessAPI = new BUSINESS_API("4380181");
    //     PAGE_DATA.businessId = "2024010520";
    //     var thod = this;
    //     businessAPI.submitMobile(this.mobile, function(json) {
    //       //后台提交验证码请求后的回调函数
    //       //倒计时120秒开启
    //       thod.orderNumber_var = json.extparam;
    //       thod.isShowMobileInput = false;
    //       thod.isShowCodeInput = true;
    //       var that = thod;
    //       if (!that.codeTimer) {
    //         that.count = 120;
    //         that.codeTimer = setInterval(() => {
    //           if (that.count > 0 && that.count <= 120) {
    //             that.count--;
    //           } else {
    //             that.isShowMobileInput = true;
    //             that.isShowCodeInput = false;
    //             that.mobile = "";
    //             that.code = "";
    //             clearInterval(that.codeTimer);
    //             that.codeTimer = null;
    //           }
    //         }, 1000);
    //       }
    //       //插码
    //       thod.getSmsCode();
    //     });
    //   }
    // },
    // code: function() {
    //   //验证码校验
    //   if (this.code.length >= 6) {
    //     //alert(this.code);
    //     let businessAPI = new BUSINESS_API("4380181");
    //     PAGE_DATA.businessId = "2024010520";
    //     this.isShowMobileInput = true;
    //     this.isShowCodeInput = false;
    //     //关闭定时器
    //     if (this.codeTimer != null) {
    //       clearInterval(this.codeTimer);
    //       this.codeTimer = null;
    //     }
    //     //插码
    //     this.imOrder();
    //     let that = this;
    //     businessAPI.submitSmsCode(
    //       that.code,
    //       function() {
    //         //验证码校验成功后的回调函数
    //         that.isSHowResultDialog = true;
    //         //插码
    //         this.comfirmOrder();
    //       },
    //       function() {
    //         //验证码校验失败后的回调函数
    //         that.isSHowResultDialog = true;
    //       }
    //     );
    //   }
    // }
  },
  created() {
    gdp("setGeneralProps", {
      global_merchantsId_var: "GDOPEN_2123031", // 商户id
      global_merchants_var: "深圳市指尖动力网络技术有限公司", // 商户名称
      global_apiId_var: "smscodechkodcommitorder", // 接口id；传产品受理的接口ID
      global_apiName_var: "短信验证及订单提交", // 调用接口名称；传产品受理的接口名称
      global_merchantsIdCity_var: "省统" //商户ID归属地市，枚举值：省统、广州、中山、云浮……
    });
  },
  mounted() {
    //this.showTurnAnimate();

    LOG_CONFIG.LOG_ORDER_PERCENT = 0.1; //订单回调比例
    LOG_CONFIG.LOG_CHANNEL = "tuia"; //上传日志渠道  目前只有两个   tuia  maomao
    this.orderId = getCurTime();

    this.viewPage();
  },
  methods: {
    okPrizeMobileBtn() {
      //手机号码校验
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      //alert(this.mobile + "-" + this.mobile.length);
      if (this.mobile.length >= 11 && reg.test(this.mobile)) {
        //提交手机号码
        let businessAPI = new BUSINESS_API("4380182");
        PAGE_DATA.businessId = "2024010520";
        var thod = this;
        businessAPI.submitMobile(this.mobile, function(json) {
          //后台提交验证码请求后的回调函数
          //倒计时120秒开启
          thod.orderNumber_var = json.extparam;
          // thod.isShowMobileInput = false;
          // thod.isShowCodeInput = true;
          thod.codeShow = false;
          var that = thod;
          if (!that.codeTimer) {
            that.count = 120;
            that.codeTimer = setInterval(() => {
              if (that.count > 0 && that.count <= 120) {
                that.count--;
              } else {
                // that.isShowMobileInput = true;
                // that.isShowCodeInput = false;
                that.mobile = "";
                that.code = "";
                that.codeShow = true;
                clearInterval(that.codeTimer);
                that.codeTimer = null;
              }
            }, 1000);
          }
        });

        thod.getSmsCode();
      }
    },
    okPrizeBtn() {
      if (this.mobile == "" || this.mobile.length < 11) {
        alert("手机号码不能为空！");
        return;
      }
      if (this.code == "") {
        //|| this.code.length < 6
        alert("验证码不能为空！");
        return;
      }
      if (this.code.length > 0) {
        //this.code.length >= 6
        let businessAPI = new BUSINESS_API("4380182");
        PAGE_DATA.businessId = "2024010520";
        // this.isShowMobileInput = true;
        // this.isShowCodeInput = false;
        this.isSHowComfirmDialog = false;
        //关闭定时器
        if (this.codeTimer != null) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
        }

        //插码
        this.imOrder();

        let that = this;
        businessAPI.submitSmsCode(
          that.code,
          function() {
            //验证码校验成功后的回调函数
            that.isSHowResultDialog = true;
            //插码
            that.comfirmOrder();
          },
          function() {
            //验证码校验失败后的回调函数
            that.isSHowResultDialog = true;
            //插码
            that.comfirmOrder();
          }
        );
      }
      // if (!$("#agreementRadio").prop("checked")) {
      //   alert("需要勾选隐私协议和条款！");
      //   return;
      // }
      //alert("ooooo");
    },
    handleComfirm() {
      // if (!this.checked) {
      //   alert("请先勾选下方已阅读详情并同意办理甘肃移动饭票联合会员业务");
      //   return;
      // }
      if (this.mobile == "" || this.mobile.length < 11) {
        alert("手机号码不能为空！");
        return;
      }
      if (this.code == "") {
        //|| this.code.length < 6
        alert("验证码不能为空！");
        return;
      }
      $("[type='checkbox']").prop("checked", true);
      //验证码校验
      if (this.mobile.length == 11) {
        this.isSHowComfirmDialog = true;
      } else {
        alert("手机号码输入错误");
      }
    },
    handleOrder() {
      this.isSHowComfirmDialog = false;
      this.okPrizeBtn();
    },
    showRules() {
      this.isSHowRuleDialog = true;
    },
    quanyi() {
      window.location.href = "https://dx.10086.cn/z_UHBQ";
    },
    viewPage() {
      console.log("entry  viewPage==");
      // gdp("track", "merchants_pageView", {
      //   pageName_var: "20元小福券7折优惠（合约12个月，每月赠送6元）", // 页面访问时当前页面名称，传具体的页面名称。
      //   merchantsId_var: "GDOPEN_2123031", // 商品所属商户id。
      //   merchantsIdCity_var: "省统", //商户ID归属地市，枚举值：省统、广州、中山、云浮……
      //   merchants_var: "深圳市指尖动力网络技术有限公司" // 商品所属商户名称。
      // });
      gdp("track", "merchants_bussinessProcessing", {
        businessType_var: "存量", // 属于存量业务则写“存量”
        goodsId_var: "YTF20YXFQ7ZYH12Y", // 业务办理时所属的商品ID。（需与能开商品编码一致）
        goodsName_var: "20元小福券7折优惠（合约12个月，每月赠送6元）", //业务办理时商品名称。
        goodsType_var: "权益", //业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
        apiId_var: "", // 调用能开接口id。（调用能开接口时赋值，如：获取短信验证码步骤传“smscodeapply”，提交订单、提交订单成功步骤传“smscodechkodcommitorder”）
        apiName_var: "", // 调用能开接口名称。（调用能开接口时赋值，如：获取短信验证码步骤传“短信验证码申请”，提交订单、提交订单成功步骤传“短信验证及订单提交”）
        merchantsId_var: "GDOPEN_2123031", // 商品所属商户id。
        merchantsIdCity_var: "省统", //商户ID归属地市，枚举值：省统、广州、中山、云浮……
        merchants_var: "深圳市指尖动力网络技术有限公司", // 商品所属商户名称。
        phoneNumber_var: "", //输入电话号码,传AES加密后的手机号
        processType_var: "页面浏览", // 业务办理时的每个办理步骤。（页面浏览、输入电话号码、获取短信验证码、输入短信验证码、立即办理、确认办理、二次确认-确认、身份认证、二次确认-取消、提交订单、提交订单成功、提交订单失败、办理成功、办理失败、支付成功、支付失败）
        errorMessage_var: "", // 业务办理失败时的失败原因明细。（网络问题、业务互斥……）
        channelId_var: "", // 下单渠道编码，没有则不传
        operatorId_var: "", // 下单工号，没有则不传
        payType_var: "话费", // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
        merchantsOrder_var: this.orderId, // 自建的订单号。
        orderNumber_var: "", // 能开接口返回的订单号。
        ordertype_var: "权益订单" // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
      });
      console.log("exit  viewPage==");
    },
    imOrder() {
      console.log("entry  imOrder==");
      this.encryptMessage();
      console.log("encryptedMessage==" + this.encryptedMessage);
      gdp("track", "merchants_bussinessProcessing", {
        businessType_var: "存量", // 属于存量业务则写“存量”
        goodsId_var: "YTF20YXFQ7ZYH12Y", // 业务办理时所属的商品ID。（需与能开商品编码一致）
        goodsName_var: "20元小福券7折优惠（合约12个月，每月赠送6元）", //业务办理时商品名称。
        goodsType_var: "权益", //业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
        apiId_var: "smscodechkodcommitorder", // 调用能开接口id。（调用能开接口时赋值，如：获取短信验证码步骤传“smscodeapply”，提交订单、提交订单成功步骤传“smscodechkodcommitorder”）
        apiName_var: "短信验证及订单提交", // 调用能开接口名称。（调用能开接口时赋值，如：获取短信验证码步骤传“短信验证码申请”，提交订单、提交订单成功步骤传“短信验证及订单提交”）
        merchantsId_var: "GDOPEN_2123031", // 商品所属商户id。
        merchantsIdCity_var: "省统", //商户ID归属地市，枚举值：省统、广州、中山、云浮……
        merchants_var: "深圳市指尖动力网络技术有限公司", // 商品所属商户名称。
        phoneNumber_var: this.encryptedMessage, //输入电话号码,传AES加密后的手机号
        processType_var: "提交订单", // 业务办理时的每个办理步骤。（页面浏览、输入电话号码、获取短信验证码、输入短信验证码、立即办理、确认办理、二次确认-确认、身份认证、二次确认-取消、提交订单、提交订单成功、提交订单失败、办理成功、办理失败、支付成功、支付失败）
        errorMessage_var: "", // 业务办理失败时的失败原因明细。（网络问题、业务互斥……）
        channelId_var: "", // 下单渠道编码，没有则不传
        operatorId_var: "", // 下单工号，没有则不传
        payType_var: "话费", // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
        merchantsOrder_var: this.orderId, // 自建的订单号。
        orderNumber_var: this.orderNumber_var, // 能开接口返回的订单号。
        ordertype_var: "权益订单" // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
      });
      console.log("exit  imOrder==");
    },
    getSmsCode() {
      console.log("entry  getSmsCode==");
      this.encryptMessage();
      console.log("encryptedMessage==" + this.encryptedMessage);
      gdp("track", "merchants_bussinessProcessing", {
        businessType_var: "存量", // 属于存量业务则写“存量”
        goodsId_var: "YTF20YXFQ7ZYH12Y", // 业务办理时所属的商品ID。（需与能开商品编码一致）
        goodsName_var: "20元小福券7折优惠（合约12个月，每月赠送6元）", //业务办理时商品名称。
        goodsType_var: "权益", //业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
        apiId_var: "smscodeapply", // 调用能开接口id。（调用能开接口时赋值，如：获取短信验证码步骤传“smscodeapply”，提交订单、提交订单成功步骤传“smscodechkodcommitorder”）
        apiName_var: "短信验证码申请", // 调用能开接口名称。（调用能开接口时赋值，如：获取短信验证码步骤传“短信验证码申请”，提交订单、提交订单成功步骤传“短信验证及订单提交”）
        merchantsId_var: "GDOPEN_2123031", // 商品所属商户id。
        merchantsIdCity_var: "省统", //商户ID归属地市，枚举值：省统、广州、中山、云浮……
        merchants_var: "深圳市指尖动力网络技术有限公司", // 商品所属商户名称。
        phoneNumber_var: this.encryptedMessage, //输入电话号码,传AES加密后的手机号
        processType_var: "获取短信验证码", // 业务办理时的每个办理步骤。（页面浏览、输入电话号码、获取短信验证码、输入短信验证码、立即办理、确认办理、二次确认-确认、身份认证、二次确认-取消、提交订单、提交订单成功、提交订单失败、办理成功、办理失败、支付成功、支付失败）
        errorMessage_var: "", // 业务办理失败时的失败原因明细。（网络问题、业务互斥……）
        channelId_var: "", // 下单渠道编码，没有则不传
        operatorId_var: "", // 下单工号，没有则不传
        payType_var: "话费", // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
        merchantsOrder_var: this.orderId, // 自建的订单号。
        orderNumber_var: "", // 能开接口返回的订单号。
        ordertype_var: "权益订单" // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
      });
      console.log("exit  getSmsCode==");
    },
    comfirmOrder() {
      console.log("entry  comfirmOrder==");
      this.encryptMessage();
      console.log("encryptedMessage==" + this.encryptedMessage);
      gdp("track", "merchants_bussinessProcessing", {
        businessType_var: "存量", // 属于存量业务则写“存量”
        goodsId_var: "YTF20YXFQ7ZYH12Y", // 业务办理时所属的商品ID。（需与能开商品编码一致）
        goodsName_var: "20元小福券7折优惠（合约12个月，每月赠送6元）", //业务办理时商品名称。
        goodsType_var: "权益", //业务办理时商品类型，与ordertype_var对应。若不清楚可咨询业务接口人。
        apiId_var: "smscodechkodcommitorder", // 调用能开接口id。（调用能开接口时赋值，如：获取短信验证码步骤传“smscodeapply”，提交订单、提交订单成功步骤传“smscodechkodcommitorder”）
        apiName_var: "短信验证及订单提交", // 调用能开接口名称。（调用能开接口时赋值，如：获取短信验证码步骤传“短信验证码申请”，提交订单、提交订单成功步骤传“短信验证及订单提交”）
        merchantsId_var: "GDOPEN_2123031", // 商品所属商户id。
        merchantsIdCity_var: "省统", //商户ID归属地市，枚举值：省统、广州、中山、云浮……
        merchants_var: "深圳市指尖动力网络技术有限公司", // 商品所属商户名称。
        phoneNumber_var: this.encryptedMessage, //输入电话号码,传AES加密后的手机号
        processType_var: "提交订单成功", // 业务办理时的每个办理步骤。（页面浏览、输入电话号码、获取短信验证码、输入短信验证码、立即办理、确认办理、二次确认-确认、身份认证、二次确认-取消、提交订单、提交订单成功、提交订单失败、办理成功、办理失败、支付成功、支付失败）
        errorMessage_var: "", // 业务办理失败时的失败原因明细。（网络问题、业务互斥……）
        channelId_var: "", // 下单渠道编码，没有则不传
        operatorId_var: "", // 下单工号，没有则不传
        payType_var: "话费", // 业务办理支付时的支付方式名称。（支付宝、微信、话费、……）
        merchantsOrder_var: this.orderId, // 自建的订单号。
        orderNumber_var: this.orderNumber_var, // 能开接口返回的订单号。
        ordertype_var: "权益订单" // 业务办理支付完成时所属订单类型名称。与goodsType_var对应，是什么商品类型就是什么类型订单。
      });
      console.log("exit  comfirmOrder==");
    },
    encryptMessage() {
      //const key = CryptoJS.enc.Utf8.parse("9e5702ead4d643fd");
      const iv = CryptoJS.enc.Utf8.parse("9e5702ead4d643fd");
      // const encrypted = CryptoJS.AES.encrypt(this.mobile, key, {
      //   iv: iv,
      //   mode: CryptoJS.mode.CBC,
      //   padding: CryptoJS.pad.Pkcs7
      // });
      var options = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      };
      let key = "9e5702ead4d643fd";
      this.encryptedMessage = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(this.mobile),
        CryptoJS.enc.Utf8.parse(key),
        options
      ).toString();
      //this.encryptedMessage = encrypted.toString();  .ciphertext
    }
  }
};
</script>
<style scoped>
* {
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  /* -webkit-appearance: none; */
}

.body {
  position: absolute;
  width: 100vw;
  height: 100vh;
  /* height: auto; */
  left: 0;
  top: 0;
  background-color: rgb(254, 99, 55);
}

.member {
  width: 750px;
  height: 5599px;
  background: url("../../static/img/mem/background.jpg") no-repeat;
  /* background: url("https://mydcdn.boshgame.com/4380327/image/background.jpg")
    no-repeat; */
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  overflow-x: hidden;
}

.input1 {
  width: 610px;
  height: 95px;
  position: absolute;
  left: 65px;
  top: 1490px;
}

.input1 input {
  width: 83%;
  border-style: none;
  height: 100%;
  background-color: rgb(255, 255, 255);
  border-radius: 25px;
  padding-left: 105px;
  outline: none;
  border: 4px solid rgb(237, 207, 175);
  font-size: 40px;
  letter-spacing: 2px;
  /* text-align: center; */
}

.input1 input::placeholder {
  color: rgb(117, 117, 117);
  font-size: 38px;
  letter-spacing: 3px;
  /* text-align: center; */
}

.input2 {
  width: 610px;
  height: 95px;
  position: absolute;
  left: 65px;
  top: 1620px;
}

.input2 input {
  width: 83%;
  border-style: none;
  height: 100%;
  background-color: rgb(255, 255, 255);
  border-radius: 25px;
  padding-left: 105px;
  outline: none;
  border: 4px solid rgb(237, 207, 175);
  font-size: 40px;
  letter-spacing: 2px;
}

.input2 input::placeholder {
  color: rgb(117, 117, 117);
  font-size: 38px;
  letter-spacing: 3px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.showPrizeBtn {
  position: absolute;
  z-index: 999;
  width: 647px;
  height: 130px;
  top: 1750px;
  left: 51px;
  background: url("../../static/img/mem/prize_btn.png") no-repeat;
  /* background: url("https://mydcdn.boshgame.com/4380327/image/prize_btn1.png")
    no-repeat; */
  background-size: 100% 100%;
  animation: scaleBtn 1.2s infinite ease-in-out;
}

.showPrizeCodeBtn {
  position: absolute;
  z-index: 999;
  width: 647px;
  height: 130px;
  top: 1750px;
  left: 51px;
  background: url("../../static/img/mem/prize_btn.png") no-repeat;
  /* background: url("https://mydcdn.boshgame.com/4380327/image/prize_btn1.png")
    no-repeat; */
  background-size: 100% 100%;
  animation: scaleBtn 1.2s infinite ease-in-out;
}

@keyframes scaleBtn {
  0% {
    transform: scale(0.95);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(0.95);
    opacity: 1;
  }
}

.showPrivacyPolicy {
  position: absolute;
  z-index: 1001;
  top: 1898px;
  left: 70px;
}

.checkbox {
  zoom: 200%;
}

.button2 {
  position: absolute;
  width: 181px;
  height: 65px;
  left: 423px;
  top: 23px;
  cursor: pointer;
  user-select: none;
  border-radius: 30px;
  overflow: hidden;
  background-color: rgb(255, 0, 0);
  border-style: none;
  font-size: 24px;
  vertical-align: middle;
  color: rgb(255, 255, 255);
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
}

.Dialog-wrap {
  position: absolute;
  width: 100vw;
  height: 4970px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 999;
}

.RuleDialog {
  position: absolute;
  z-index: 999;
  width: 508px;
  height: 822px;
  top: 272px;
  left: 121px;
  background: url("../../static/img/mem/rule_bg.png") no-repeat;
  background-size: 100% 100%;
}

.closeBtn {
  position: absolute;
  width: 60px;
  height: 60px;
  left: 224px;
  top: 840px;
  z-index: 1001;
}

.rule {
  position: absolute;
  width: 99px;
  height: 41px;
  left: 650px;
  top: 25px;
  /* background: url("../../static/img/mem/rule.png") no-repeat; */
  background: url("https://mydcdn.boshgame.com/4380327/image/rule.png")
    no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  background-color: none;
  overflow: hidden;
}

.container {
  position: absolute;
  z-index: 999;
  width: 628px;
  height: 55px;
  top: 820px;
  left: 61px;
  background-color: rgb(0, 167, 18);
  border-radius: 45px;
  /* border: 1px solid #eee; */
  overflow: hidden;
  display: inline-block;
}

@keyframes text-scroll {
  0% {
    /* transform: translateX(40%); */
    transform: translateX(689px);
  }
  /* 50% {
    transform: translateX(0);
  } */
  100% {
    transform: translateX(-100%);
  }
}

.text {
  position: absolute;
  height: 55px;
  line-height: 55px;
  text-align: center;
  color: white;
  font-size: 30px;
  animation: text-scroll 15s linear infinite;
  white-space: nowrap;
}

.quanyi1 {
  position: absolute;
  width: 392px;
  height: 81px;
  left: 105px;
  top: 2116px;
  background: url("../../static/img/mem/anniu.png") no-repeat;
  /* background: url("https://mydcdn.boshgame.com/4380327/image/rule.png")
    no-repeat; */
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  background-color: none;
  overflow: hidden;
}

.ComfirmDialog {
  position: absolute;
  z-index: 1000;
  width: 718px;
  height: 843px;
  top: 300px;
  left: 16px;
  background: url("../../static/img/mem/comfirm.png") no-repeat;
  background-size: 100% 100%;
  padding-left: 0px;
  outline: none;
}

.ComfirmButton {
  position: absolute;
  width: 258px;
  height: 85px;
  left: 420px;
  top: 700px;
  background: url("../../static/img/mem/ok1.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  background-color: none;
  border-style: none;
}

.ExitButton {
  position: absolute;
  width: 36px;
  height: 36px;
  left: 650px;
  top: 30px;
  background: url("../../static/img/mem/no1.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  background-color: none;
  border-style: none;
}
</style>



// WEBPACK FOOTER //
// src/view/mem.vue